/** Параллельная штриховка гипсокартонной перегородки. */
import { LineHatch, type WallHatchProps } from "./WallHatchGeometry";

export const DrywallHatch = ({ outline }: WallHatchProps) => (
	<LineHatch outline={outline} angle={0} spacing={5} />
);
